import React, { memo, useEffect, useState, useCallback, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { createSelector } from 'reselect';
import { useLocation, useHistory } from 'react-router-dom';

import Swiper from 'react-id-swiper';
import 'swiper/css/swiper.css';

import { CONTEXT } from '../../config';
import { setActiveMenu } from '../../actions/layout';
import { logging, logPostInfo } from '../../actions/log';
import WallpaperOpt from '../../components/WallpaperOpt/WallpaperOpt';
import styles from './WallpaperDetail.module.less';
import { removeClass, addClass } from '../../utils/utils';
import {
  getWpScreenList,
  getRecommendList,
  getCategoryImgInfo,
  getMineCollectList,
  getMineSetupList,
  getAuthorShowreel,
  getDetailReco,
  getRankList,
} from '../../actions/wallpaper';
import { WP_DOWNLOAD_WAIT, WP_DOWNLOAD_ING, WP_DOWNLOAD_FINISHED } from '../../constants/wallpaper';
import { getQueryString, logNative, getUrlByTargetContent } from '../../utils/utils';
import transparent from '../../static/transparent.svg';
import wpAuthorDefault from '../../static/wp_author_default.png';
import { message } from 'antd';

const selectLogInfo = createSelector(
  state => state.log,
  log => log.logInfo,
);

const selectWpDetailReco = createSelector(
  state => state.wallpaper,
  wallpaper => wallpaper.wpDetailReco,
);

const selectWpRankList = createSelector(
  state => state.wallpaper,
  wallpaper => wallpaper.rankList,
);
const selectWpScreen = createSelector(
  state => state.wallpaper,
  wallpaper => wallpaper.wpScreen,
);
const selectRecommendInfo = createSelector(
  state => state.wallpaper,
  wallpaper => wallpaper.recommendInfo,
);
const selectCategoryInfo = createSelector(
  state => state.wallpaper,
  wallpaper => wallpaper.categoryInfo,
);
const selectMineInfo = createSelector(
  state => state.wallpaper,
  wallpaper => wallpaper.mineInfo,
);
const selectDownloadImgs = createSelector(
  state => state.wallpaper,
  wallpaper => wallpaper.wpDowloadImgs,
);

const selectWpAuthorShowreel = createSelector(
  state => state.wallpaper,
  wallpaper => wallpaper.wpAuthorShowreel,
);

const selectWpPreview = createSelector(
  state => state.wallpaper,
  wallpaper => wallpaper.wpPreviewInfo,
);

export default memo(() => {
  const dispatch = useDispatch();
  const location = useLocation();
  const history = useHistory();
  const logInfoData = useSelector(selectLogInfo);

  const rankList = useSelector(selectWpRankList);
  const detailReco = useSelector(selectWpDetailReco);
  const wpScreen = useSelector(selectWpScreen);
  const recommendInfo = useSelector(selectRecommendInfo);
  const categoryInfo = useSelector(selectCategoryInfo);
  const mineInfo = useSelector(selectMineInfo);
  const authorShowreel = useSelector(selectWpAuthorShowreel);
  // 正在任务执行中的壁纸
  const wpDowloadImgs = useSelector(selectDownloadImgs);
  // 全屏预览壁纸
  const wpPreview = useSelector(selectWpPreview);

  const midlleSwiperRef = useRef(null);
  const smallSwiperRef = useRef(null);
  const [showImg, setShowImg] = useState([]);

  const code = getQueryString('code', location.search) || '';
  const pageTage = getQueryString('pageTage', location.search) || '';
  const tagId = getQueryString('tagId', location.search) || '';
  const classId = getQueryString('classId', location.search) || '';
  const colorId = getQueryString('colorId', location.search) || '';
  const pageSource = getQueryString('pageSource', location.search) || '';
  const wallpaperId = getQueryString('wallpaperId', location.search) || '';
  const authorId = getQueryString('authorId', location.search) || '';

  /**
   * 统计页面浏览时长
   */
  useEffect(() => {
    const initTime = +new Date();
    return () => {
      const leaveTime = +new Date();
      dispatch(
        logging({
          category: 'I',
          action: 'View_Time',
          label: '',
          param2: {
            source: `Wallpaper_Detail`,
            source_p: logInfoData.source_p,
            source_pp: logInfoData.source_pp,
            initTime,
            leaveTime,
            time: leaveTime - initTime,
            code,
            pageTage,
            tagId,
            classId,
            colorId,
            pageSource,
            wallpaperId,
            authorId,
          },
        }),
      );
    };
  }, []);

  useEffect(() => {
    // 更新页面 PV
    dispatch(
      logging({
        category: 'Wallpaper',
        action: 'P_Wallpaper_Detail',
        label: '',
        param2: {
          source: `Wallpaper_Detail`,
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
          wallpaperId,
        },
      }),
    );
    dispatch(
      logPostInfo({
        source: `Wallpaper_Detail`,
        source_p: logInfoData.source_p,
        source_pp: logInfoData.source_pp,
      }),
    );
    window.wpDetailOpenPageTime = +new Date();
    loggingPVDuration();
    dispatch(getDetailReco({ pageType: 'wallpaperDetail' }));
  }, [dispatch]);

  // 详情页面浏览时长打桩每隔30秒打一次，限制3分钟内
  const loggingPVDuration = useCallback(() => {
    const spaceTime = 30;
    setTimeout(() => {
      const diffTime = +new Date() - window.wpDetailOpenPageTime;
      if (window.location.pathname.indexOf('wpdetail') > -1 && diffTime < 6 * spaceTime * 1000) {
        dispatch(
          logging({
            category: 'Wallpaper',
            action: 'I_Wallpaper_Detail_ViewTime',
            label: '',
            param2: {
              source: `Wallpaper_Detail`,
              source_p: logInfoData.source_p,
              source_pp: logInfoData.source_pp,
              time: parseInt(diffTime / 1000, 10),
              wallpaperId,
            },
          }),
        );
        loggingPVDuration();
      }
    }, spaceTime * 1000);
  }, [dispatch]);

  /**
   * 进入详情页面，如果壁纸数量小于48且小于最大壁纸数量。重新请求数据
   * screen: 锁屏以及外部调用
   * recommendBanner: 推荐页的banner
   * recommend: 推荐页面
   * category: 分类页面
   * mine: 我的页面
   * authorDetail: 作者详情页面
   * rank: 榜单专题页面 code为专题code
   */
  useEffect(() => {
    // 设置菜单选中项
    dispatch(setActiveMenu(`${CONTEXT}/wpdetail`));
    // 如果数据为空，则重新获取数据
    if (pageSource === 'screen') {
      dispatch(
        getWpScreenList({ ...wpScreen.pagenation, skip: 0, limit: 48, wallpaperId, refresh: true }),
      );
    } else if (pageSource === 'recommendBanner') {
      dispatch(
        getRecommendList({
          ...recommendInfo.pagenation,
          skip: 0,
          limit: 48,
          wallpaperId,
          refresh: true,
        }),
      );
    } else if (
      pageSource === 'recommend' &&
      (!recommendInfo.list || (recommendInfo.list && recommendInfo.list.length < 48))
    ) {
      dispatch(
        getRecommendList({ ...recommendInfo.pagenation, skip: 0, limit: 48, refresh: true }),
      );
    } else if (
      pageSource === 'category' &&
      (!categoryInfo.list ||
        (categoryInfo.list && categoryInfo.list.length < 48) ||
        (categoryInfo.pagenation &&
          (categoryInfo.pagenation.tagId !== tagId ||
            categoryInfo.pagenation.classId !== classId ||
            categoryInfo.pagenation.colorId !== colorId)))
    ) {
      dispatch(
        getCategoryImgInfo({
          ...categoryInfo.pagenation,
          skip: 0,
          limit: 48,
          tagId,
          classId,
          colorId,
          refresh: true,
        }),
      );
    } else if (
      pageSource === 'mine' &&
      (!mineInfo.list ||
        (mineInfo.list && mineInfo.list.length < 48) ||
        (mineInfo.pagenation && mineInfo.pagenation.tagId !== pageTage))
    ) {
      const param = {
        ...mineInfo.pagenation,
        tagId: 'collect',
        skip: 0,
        limit: 48,
        refresh: true,
      };
      pageTage === 'collect'
        ? dispatch(getMineCollectList({ ...param, tagId: 'collect' }))
        : dispatch(getMineSetupList({ ...param, tagId: 'setup' }));
    } else if (
      pageSource === 'authorDetail' &&
      (!authorShowreel.list ||
        (authorShowreel.list && authorShowreel.list.length < 48) ||
        (authorShowreel.pagenation && authorShowreel.pagenation.authorId !== authorId))
    ) {
      dispatch(
        getAuthorShowreel({
          ...authorShowreel.pagenation,
          authorId,
          skip: 0,
          limit: 48,
          refresh: true,
        }),
      );
    } else if (
      pageSource === 'rank' &&
      (!rankList ||
        !rankList.list ||
        !rankList.code ||
        (rankList && rankList.wallpaperId && rankList.wallpaperId !== wallpaperId) ||
        (rankList.list &&
          rankList.pagenation &&
          rankList.list.length < 48 &&
          rankList.list.length < rankList.pagenation.count) ||
        (rankList.code && rankList.code !== code))
    ) {
      dispatch(
        getRankList({
          ...rankList.pagenation,
          code,
          wallpaperId,
          skip: 0,
          limit: 48,
          refresh: true,
        }),
      );
    }
  }, [dispatch]);

  // 设置swiper数据
  useEffect(() => {
    if (pageSource === 'screen') {
      if (wpScreen.wallpapers && wpScreen.load === false && wpScreen.wallpapers.length > 0) {
        setShowImg(wpScreen.wallpapers);
      }
      if (wpScreen.status === 2) {
        // 锁屏壁纸获取失败，则展示壁纸首页
        history.push(`${CONTEXT}/wprecommend`);
      }
    } else if (pageSource === 'recommendBanner') {
      if (
        recommendInfo.list &&
        recommendInfo.load === false &&
        recommendInfo.pagenation.wallpaperId === wallpaperId &&
        (recommendInfo.list.length >= 48 ||
          (recommendInfo.pagenation.count < 48 &&
            recommendInfo.list.length === recommendInfo.pagenation.count))
      ) {
        setShowImg(recommendInfo.list);
      }
    } else if (pageSource === 'recommend') {
      if (
        recommendInfo.list &&
        recommendInfo.load === false &&
        (recommendInfo.list.length >= 48 ||
          (recommendInfo.pagenation.count < 48 &&
            recommendInfo.list.length === recommendInfo.pagenation.count))
      ) {
        setShowImg(recommendInfo.list);
      }
    } else if (pageSource === 'category') {
      if (
        categoryInfo.list &&
        categoryInfo.load === false &&
        categoryInfo.pagenation.tagId === tagId &&
        (categoryInfo.list.length >= 48 ||
          (categoryInfo.pagenation.count < 48 &&
            categoryInfo.list.length === categoryInfo.pagenation.count))
      ) {
        setShowImg(categoryInfo.list);
      }
    } else if (pageSource === 'mine') {
      if (
        mineInfo.list &&
        mineInfo.load === false &&
        mineInfo.pagenation.tagId === pageTage
        // 由于后端同步数据问题，会出现list.length < 48 但是pagenation.count > 48所以改为不判断长度直接setShowImg
        // && (mineInfo.list.length >= 48 ||
        //   (mineInfo.pagenation.count < 48 && mineInfo.list.length <= mineInfo.pagenation.count))
      ) {
        setShowImg(mineInfo.list);
      }
    } else if (pageSource === 'authorDetail') {
      if (
        authorShowreel.list &&
        authorShowreel.load === false &&
        authorShowreel.pagenation.authorId === authorId &&
        (authorShowreel.list.length >= 48 ||
          (authorShowreel.pagenation.count < 48 &&
            authorShowreel.list.length === authorShowreel.pagenation.count))
      ) {
        setShowImg(authorShowreel.list);
      }
    } else if (pageSource === 'rank') {
      if (
        rankList.list &&
        rankList.load === false &&
        rankList.code === code &&
        (rankList.list.length >= 48 ||
          (rankList.pagenation.count < 48 && rankList.list.length === rankList.pagenation.count))
      ) {
        setShowImg(rankList.list);
      }
    }
  }, [wpScreen, recommendInfo, categoryInfo, mineInfo, authorShowreel, rankList]);

  /**
   * 注册键盘 事件的一些特殊处理
   */
  useEffect(() => {
    if (judgeDom()) {
      document.onkeydown = function(event) {
        const ev = event || window.event;
        if (ev.code === 'KeyP' && ev.ctrlKey) {
          const midlleSwiper = midlleSwiperRef && midlleSwiperRef.current.swiper;
          if (midlleSwiper && showImg.length > 0) {
            const showImgActive = showImg[midlleSwiper.activeIndex];
            showImgActive && message.info(`当前壁纸ID: ${showImgActive.wallpaperId}`);
            logNative(
              `展示壁纸ID：${showImgActive.wallpaperId}, 顺序：${midlleSwiper.activeIndex}`,
              showImg,
              true,
              true,
            );
          }
        }
      };
    }
  }, [midlleSwiperRef, smallSwiperRef, showImg, wpPreview]);

  // 初始化swiper
  useEffect(() => {
    if (showImg && judgeDom()) {
      const midlleSwiper = midlleSwiperRef.current.swiper;
      const smallSwiper = smallSwiperRef.current.swiper;
      let activeIndex = 2;
      if (wallpaperId) {
        showImg.forEach((item, i) => {
          if (item.wallpaperId === wallpaperId) {
            activeIndex = i;
          }
        });
        midlleSwiper.slideTo(activeIndex, 10, false);
        smallSwiper.slideTo(activeIndex, 10, false);
      }
      onMiddleChangeStart();
    }
  }, [midlleSwiperRef, smallSwiperRef, showImg, wallpaperId]);

  const judgeDom = useCallback(() => {
    return (
      midlleSwiperRef &&
      midlleSwiperRef.current &&
      midlleSwiperRef.current.swiper &&
      smallSwiperRef &&
      smallSwiperRef.current &&
      smallSwiperRef.current.swiper
    );
  }, [midlleSwiperRef, smallSwiperRef]);

  const onMiddleChangeStart = useCallback(() => {
    if (judgeDom()) {
      const slider = document.getElementsByClassName('small_slider');
      const sliderActive = document.getElementsByClassName('small_slider_active');
      const midlleSwiper = midlleSwiperRef.current.swiper;
      const smallSwiper = smallSwiperRef.current.swiper;
      smallSwiper.slideTo(midlleSwiper.activeIndex);
      if (sliderActive && sliderActive.length > 0) {
        [...sliderActive].map(item => {
          removeClass(item, 'small_slider_active');
        });
      }
      if (slider.length > 0) {
        [...slider].map((item, i) => {
          if (i === midlleSwiper.activeIndex) {
            addClass(item, 'small_slider_active');
          }
        });
      }
    }
  }, [midlleSwiperRef, smallSwiperRef]);

  const onSmallClick = useCallback(() => {
    if (judgeDom()) {
      const midlleSwiper = midlleSwiperRef.current.swiper;
      const smallSwiper = smallSwiperRef.current.swiper;
      if (smallSwiper.clickedIndex !== undefined) {
        midlleSwiper.slideTo(smallSwiper.clickedIndex);
      }
    }
  }, [midlleSwiperRef, smallSwiperRef]);

  const onSmallChangeStart = useCallback(() => {
    if (judgeDom()) {
      const slider = document.getElementsByClassName('small_slider');
      const sliderActive = document.getElementsByClassName('small_slider_active');
      const midlleSwiper = midlleSwiperRef.current.swiper;
      const smallSwiper = smallSwiperRef.current.swiper;
      smallSwiper.slideTo(midlleSwiper.activeIndex);
      if (sliderActive && sliderActive.length > 0) {
        [...sliderActive].map(item => {
          removeClass(item, 'small_slider_active');
        });
      }
      if (slider.length > 0) {
        [...slider].map((item, i) => {
          if (i === midlleSwiper.activeIndex) {
            addClass(item, 'small_slider_active');
          }
        });
      }
    }
  });

  const onError = function(e) {
    if (e.currentTarget && e.currentTarget.src) {
      e.currentTarget.src = transparent;
    }
  };

  const handleAuthor = useCallback(author => {
    // 更新页面 PV
    dispatch(
      logging({
        category: 'Wallpaper',
        action: 'C_Wallpaper_AuthorMark',
        label: '',
        param2: {
          source: `Wallpaper_Detail`,
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
          authorId: author.authorId,
          authorName: author.authorName,
        },
      }),
    );
    dispatch(
      logPostInfo({
        source_p: logInfoData.source,
        source_pp: logInfoData.source_p,
      }),
    );
    history.push(`${CONTEXT}/wpauthordetail?authorId=${author.authorId}`);
  });

  const handleDetailRecoBanner = useCallback(() => {
    // 更新页面 PV
    dispatch(
      logging({
        category: 'Wallpaper',
        action: 'C_Wallpaper_Viewmore',
        label: '',
        param2: {
          source: `Wallpaper_Detail`,
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
          targetType: detailReco.targetType,
          targetContent: encodeURIComponent(detailReco.targetContent),
          wallpaperId,
        },
        param3: detailReco.bizInfo,
      }),
    );
    dispatch(
      logPostInfo({
        source_p: logInfoData.source,
        source_pp: logInfoData.source_p,
      }),
    );
    if (
      detailReco.targetType === '1' ||
      detailReco.targetType === '3' ||
      detailReco.targetType === '11'
    ) {
      let url = `${CONTEXT}/wpcategory`;
      if (detailReco.targetType && detailReco.targetContent) {
        url = getUrlByTargetContent(detailReco);
      }
      logNative(
        `壁纸详情页面点击随便看看${detailReco.targetType} ${detailReco.targetContent} ${url}`,
        detailReco,
        true,
        true,
      );
      history.push(url);
    } else if (detailReco.targetType === '2' && detailReco.targetContent) {
      try {
        const targetContent = JSON.parse(detailReco.targetContent) || {};
        window.open(targetContent.targetUrl);
      } catch (error) {
        logNative(`壁纸详情页面点击随便看看 失败 ${JSON.stringify(detailReco)}`, {}, true, true);
      }
    } else {
      history.push(`${CONTEXT}/wprecommend`);
    }
  }, [detailReco]);

  const midlleParam = {
    speed: 500,
    keyboard: true,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    on: {
      slideChangeTransitionStart(e) {
        onMiddleChangeStart();
      },
    },
  };
  let smallParam = {
    speed: 500,
    spaceBetween: 20,
    slidesPerView: 'auto',
    on: {
      click(e) {
        onSmallClick();
      },
      slideChangeTransitionStart() {
        onSmallChangeStart();
      },
    },
  };
  /**
   * smallSwiper,由于当img长度小于5个的时候，不能让选中图的居中。
   * 即这些属性不生效，并且js报错
   * slidesPerView: 5,
   * allowTouchMove: true,
   * slideToClickedSlide: true,
   * centeredSlides: true,
   * centeredSlidesBounds: true,
   * 所以showImg.length > 5时，做处理让选中的图居中。优化这个swiper的bug
   */
  if (showImg && showImg.length > 5) {
    smallParam = {
      ...smallParam,
      slidesPerView: 5,
      allowTouchMove: true,
      slideToClickedSlide: true,
      centeredSlides: true,
      centeredSlidesBounds: true,
    };
  }

  if (!showImg || showImg.length === 0) {
    return '';
  }

  return (
    <>
      <div className={styles.wpdetail}>
        <React.Fragment>
          <div className="wpdetail_middle">
            <Swiper {...midlleParam} ref={midlleSwiperRef}>
              {showImg &&
                showImg.length > 0 &&
                showImg.map((item, i) => {
                  let wallpaperImgShow = {};
                  if (item.wallpaperImg && item.wallpaperImg[0] && item.wallpaperImg[0].uri) {
                    wallpaperImgShow = item.wallpaperImg[0];
                  } else if (
                    item.wallpaperImg &&
                    item.wallpaperImg[1] &&
                    item.wallpaperImg[1].uri
                  ) {
                    wallpaperImgShow = item.wallpaperImg[1];
                  }
                  return (
                    <div className="midlle_slider" key={i}>
                      <img
                        className="midlle_img"
                        src={wallpaperImgShow.uri || transparent}
                        onError={onError}
                        alt="img"
                      />
                      <div className="wp_mine_opt">
                        <WallpaperOpt
                          wallpaper={{ ...item }}
                          cardInfo={{
                            isBig: true,
                            isCollect: true,
                            isWallpaper: true,
                            isPreview: true,
                          }}
                          logInfo={{ source: 'Wallpaper_Detail' }}
                        />
                      </div>
                      {item.author && item.author.authorName && (
                        <div className="wp_mine_author">
                          <img
                            className="wp_mine_author_header"
                            src={item.author.headPortrait || wpAuthorDefault}
                            onClick={() => handleAuthor(item.author)}
                            alt=""
                          />
                          <div
                            className="wp_mine_author_name"
                            title={item.author.authorName}
                            onClick={() => handleAuthor(item.author)}
                          >
                            {item.author.authorName}
                          </div>
                          {item.author.authorDesc && (
                            <div
                              className="wp_mine_author_desc"
                              dangerouslySetInnerHTML={{
                                __html: item.author.authorDesc.split('\n').join('<br/>'),
                              }}
                            />
                          )}
                          {item.wallpaperDesc && (
                            <div
                              className="wp_mine_author_content"
                              dangerouslySetInnerHTML={{
                                __html: item.wallpaperDesc.split('\n').join('<br/>'),
                              }}
                            />
                          )}
                        </div>
                      )}
                    </div>
                  );
                })}
            </Swiper>
          </div>
          <div className="wpdetail_small">
            <Swiper {...smallParam} ref={smallSwiperRef}>
              {showImg &&
                showImg.length > 0 &&
                showImg.map((item, i) => {
                  if (item.wallpaperImg && item.wallpaperImg[0] && item.wallpaperImg[0].uri) {
                    const found = wpDowloadImgs.find(wp => wp.wallpaperId === item.wallpaperId);
                    return (
                      <div className={'small_slider'} key={i}>
                        <img
                          className="small_img"
                          src={item.wallpaperImg[0].uri || transparent}
                          onError={onError}
                          alt="img"
                        />
                        {found &&
                          (found.status === WP_DOWNLOAD_WAIT ||
                            found.status === WP_DOWNLOAD_ING ||
                            found.status === WP_DOWNLOAD_FINISHED) && (
                            <div className="wpimg_busying">
                              <div className="wpimg_busying_progress">
                                <div
                                  className="inner"
                                  style={{
                                    width: `${found.progress}%`,
                                  }}
                                ></div>
                              </div>
                            </div>
                          )}
                      </div>
                    );
                  }
                  return '';
                })}

              <div
                className="small_img_reco"
                onClick={() => {
                  handleDetailRecoBanner();
                }}
              >
                {detailReco &&
                  detailReco.contentImg &&
                  detailReco.targetType &&
                  detailReco.targetContent &&
                  detailReco.targetContent.indexOf('wpdetail') === -1 && (
                    <React.Fragment>
                      <div className="small_img_reco_desc">
                        {detailReco.contentDesc || '随便逛逛'}
                      </div>
                      <img className="small_img_reco_img" src={detailReco.contentImg} />
                    </React.Fragment>
                  )}
              </div>
            </Swiper>
          </div>
        </React.Fragment>
      </div>
    </>
  );
});
